import { IGetCargoTreinamentosUseCase } from "../../../presentation/useCases/read/get_cargo_treinamentos_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { CargoTreinamento } from "../../models/cargo_treinamento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetCargoTreinamentosUseCase
 */

export class GetCargoTreinamentosUseCase extends BasePaginatedUseCase<CargoTreinamento> implements IGetCargoTreinamentosUseCase {
  constructor(private readonly repository: IRhRepository) {
    super();
  }

  async getCargoTreinamentos(
    idCargo: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getCargoTreinamentos(
      idCargo,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalPages = response.totalPages;

  }
}
